module.exports = __webpack_public_path__ + "img/limited-time-award-1.a2a74395.png";